export const CORE_HOOKS_EN = {
    // ── channels and why a delivery was not sent (H4) ──
    'value.channel.push': 'Push to the phone',
    'value.skip_reason.channel_off': 'Channel not switched on',
    'value.skip_reason.no_device': 'No phone registered',
    'value.skip_reason.closed': 'Alert closed first',
    // ── an alert closed by a later event or by hand (H3) ──
    'notifications.closed': 'Closed',
    'notifications.closed.resolved': 'What it warned about is resolved',
    'value.progress.closed': 'Alert closed',
    'screen.notifications.rules.column.close_text': 'Closed by',
    'screen.notifications.rules.field.close_on_event': 'Closed when this happens',
    'screen.notifications.rules.field.close_on_event.help': 'Optional. A later event that says what the alert warned of is put right. Its open alerts stop escalating and no longer wait for an acknowledgement.',
    'screen.notifications.rules.field.close_match': 'Matching fields',
    'screen.notifications.rules.field.close_match.help': "One line per pair, alert_field = event_field: the field of this rule's event and the field of the closing event that name the same thing. One to three lines.",
    'screen.notifications.deliveries.action.close_alert': 'Close the alert',
    'screen.notifications.deliveries.field.note': 'What put it right',
    'screen.notifications.deliveries.field.note.help': 'The alert stops escalating and no longer waits for an acknowledgement. Its unsent copies are not sent. Kept with who closed it.',
    'notifications.refusal.rule.close_event_shape': 'Name the closing event as module.entity.fact, in lower case, or clear both fields.',
    'notifications.refusal.rule.close_own_event': 'A rule cannot be closed by an event of the notifications module itself.',
    'notifications.refusal.rule.close_match_shape': 'Line {line}: write alert_field = event_field.',
    'notifications.refusal.rule.close_match_required': 'Say which field of the closing event names the same thing as the alert.',
    'notifications.refusal.rule.close_too_many': 'At most {max} closing events, and {max} matching lines each.',
    'notifications.refusal.alert.not_found': 'No such alert.',
    'notifications.refusal.alert.already_closed': 'This alert is already closed.',
    // ── a delivery sent again by a person (H2) ──
    'value.progress.resent': 'Sent again, on its way',
    'screen.notifications.deliveries.column.resend_count': 'Sent again',
    'screen.notifications.deliveries.column.alert_closed_at': 'Alert closed',
    'screen.notifications.deliveries.action.resend': 'Send again',
    'screen.notifications.deliveries.field.reason': 'Why',
    'screen.notifications.deliveries.field.reason.help': 'Optional. The same notice goes out again on its channel; the address, consent and template are checked again first. At most three times.',
    'notifications.refusal.delivery.resend_in_app': 'The bell holds it already: there is nothing to send again.',
    'notifications.refusal.delivery.resend_pending': 'It is still on its way.',
    'notifications.refusal.delivery.resend_blocked': "It was not sent by the person's choice, or its alert is closed; sending it again would override that.",
    'notifications.refusal.delivery.resend_limit': 'Sent again {max} times already.',
    'notifications.refusal.delivery.resend_too_soon': 'It was sent again under {minutes} minutes ago. Try again shortly.',
    // ── who issued a document (H6) ──
    'documents.items.field.issuer_name': 'Issued by',
    'documents.items.field.issuer_name.help': 'The issuing authority, in words. Required when the type asks who issued it.',
    'documents.items.field.issuer_party_id': 'Issuing party',
    'documents.items.field.issuer_party_id.help': 'Optional: the issuer as a party on the register. With no words, its name is written as it is now.',
    'documents.items.col.issuer_name': 'Issued by',
    'documents.items.col.issuer_party_id': 'Issuing party',
    'documents.types.field.issuer_required': 'Say who issued it',
    'documents.types.field.issuer_required.help': 'A new document of this type is refused without its issuing authority. What was filed before stays as it was.',
    'documents.types.col.issuer_required': 'Says who issued it',
    'documents.refusal.issuer_required': 'This type of document says who issued it: name the issuing authority.',
    'documents.refusal.issuer_party_unknown': 'No such party on the register, or it was merged into another.',
    'documents.refusal.issuer_party_unavailable': 'The parties register did not answer. Try again shortly.',
    'change.field.document.issuer_name': 'Issued by',
    'change.field.document.issuer_party_id': 'Issuing party',
    'change.field.type.issuer_required': 'Says who issued it',
    // ── who viewed a file (H7) ──
    'attachments.col.seen_by_party': 'Seen by the party',
    'attachments.seen.seen': 'Seen by the party',
    'attachments.col.portal_first_viewed_at': 'First seen by the party',
    'attachments.col.viewers': 'Viewers',
    'attachments.action.views': 'Who viewed it',
    'attachments.views.title': 'Who viewed {file}',
    'attachments.views.lede': 'Each person issued a link to this file, the latest first.',
    'attachments.views.empty': 'Nobody has viewed this file yet.',
    'attachments.views.kind.member': 'Member',
    'attachments.views.kind.portal': 'The party',
    'attachments.views.first': 'First viewed',
    'attachments.views.last': 'Last viewed',
    'attachments.views.count': 'Times',
    'attachments.views.unnamed_member': 'A former member',
    'attachments.views.unnamed_party': 'A party you may not see',
    'attachments.views.more': 'The latest {shown} of {total} viewers are shown.',
    'attachments.views.no_row': 'Open this from a file on the record.',
    'attachments.refusal.view_not_recorded': 'The view could not be recorded, so no link was issued. Try again shortly.',
    // ── a file's fingerprint, and a capture of now (H8) ──
    'attachments.refusal.file_reused': 'This same file was attached before. A file of this kind is taken anew.',
    'attachments.refusal.file_too_large_to_check': 'This file is too large to check that it was not attached before.',
    'attachments.refusal.capture_required': 'A file of this kind says when it was taken.',
    'attachments.refusal.capture_too_old': 'This was taken more than {max_age_minutes} minutes ago. Take it again.',
    'attachments.refusal.capture_in_future': 'When it was taken is later than now. Check the device\'s clock.',
    'media.refusal.reused': 'The same file was already claimed under this scope.',
    'media.refusal.not_fingerprinted': 'The file has no fingerprint, so it cannot be claimed.',
    'media.refusal.not_ready': 'The file has not finished uploading.',
    'media.refusal.claimed_elsewhere': 'The file is already claimed under another scope.',
    'media.refusal.scope': 'The scope is lowercase letters, digits, _ and dots.',
    'media.refusal.sha256': 'The fingerprint is 64 hexadecimal characters.',
    'media.refusal.fingerprint_mismatch': 'The uploaded content does not match its declared fingerprint.',
    'media.refusal.not_your_file': 'Only who stored the file may claim it.',
    'media.refusal.not_found': 'This file is not in this workspace.',
    'change.field.file.sha256': 'Fingerprint',
    'change.field.file.fingerprint_scope': 'Claimed under',
    'change.field.file.claimed_at': 'Claimed on',
    // ── figures and a screen to open on a rule (H9) ──
    'screen.notifications.rules.field.figures': 'Figures',
    'screen.notifications.rules.field.figures.help': 'Numbers the alert shows from its event, in the bell and in an email: the event\'s field, a name in each language, and what kind of number it is. Up to eight.',
    'screen.notifications.rules.field.figures.field': 'Event field',
    'screen.notifications.rules.field.figures.name_ar': 'Name in Arabic',
    'screen.notifications.rules.field.figures.name_en': 'Name in English',
    'screen.notifications.rules.field.figures.kind': 'Kind',
    'screen.notifications.rules.field.link': 'Opens on',
    'screen.notifications.rules.field.link.help': 'The screen the alert opens on, written module/screen. Empty: the record the event names, or none.',
    'screen.notifications.rules.action.create.section.shows': 'What it shows',
    'screen.notifications.rules.action.edit.section.shows': 'What it shows',
    'screen.notifications.rules.column.figures_text': 'Figures',
    'screen.notifications.rules.column.link': 'Opens on',
    'value.figure_kind.count': 'Count',
    'value.figure_kind.percent': 'Percent',
    'value.figure_kind.minutes': 'Minutes',
    'value.figure_kind.money': 'Amount',
    'notifications.figures': 'Figures',
    'notifications.refusal.rule.figures_shape': 'Figures are a list: the event field, a name in each language and the kind.',
    'notifications.refusal.rule.figures_too_many': 'At most {max} figures.',
    'notifications.refusal.rule.figure_field': 'Figure {line}: write the event field it reads, such as counts.open.',
    'notifications.refusal.rule.figure_name': 'Figure {line}: a name in Arabic and in English, at most {max} characters each.',
    'notifications.refusal.rule.figure_kind': 'Figure {line}: a count, a percent, minutes or an amount.',
    'notifications.refusal.rule.link_shape': 'Write the screen as module/screen.',
    'change.field.rule.figures': 'Figures',
    'change.field.rule.link': 'Opens on',
};
export const CORE_HOOKS_AR = {
    'value.channel.push': 'إشعار فوري على الجوال',
    'value.skip_reason.channel_off': 'القناة غير مفعّلة',
    'value.skip_reason.no_device': 'لا جوال مسجّل',
    'value.skip_reason.closed': 'أُغلق التنبيه قبلها',
    'notifications.closed': 'أُغلق',
    'notifications.closed.resolved': 'انتهى ما نبّه إليه',
    'value.progress.closed': 'أُغلق التنبيه',
    'screen.notifications.rules.column.close_text': 'يُغلقه',
    'screen.notifications.rules.field.close_on_event': 'يُغلق عندما يحدث',
    'screen.notifications.rules.field.close_on_event.help': 'اختياري. حدثٌ لاحق يقول إن ما نبّه إليه التنبيه قد عولج؛ فتتوقف تنبيهاته المفتوحة عن التصعيد ولا تنتظر إقرارًا.',
    'screen.notifications.rules.field.close_match': 'الحقول المتطابقة',
    'screen.notifications.rules.field.close_match.help': 'سطر لكل زوج بالصيغة alert_field = event_field: حقل حدث هذه القاعدة وحقل الحدث المُغلِق اللذان يسمّيان الشيء نفسه. من سطر إلى ثلاثة.',
    'screen.notifications.deliveries.action.close_alert': 'إغلاق التنبيه',
    'screen.notifications.deliveries.field.note': 'ما الذي عالجه',
    'screen.notifications.deliveries.field.note.help': 'يتوقف التنبيه عن التصعيد ولا ينتظر إقرارًا، ولا تُرسل نسخه التي لم تُرسل بعد. ويُحفظ مع من أغلقه.',
    'notifications.refusal.rule.close_event_shape': 'اكتب الحدث المُغلِق بالصيغة module.entity.fact بأحرف صغيرة، أو أفرغ الحقلين.',
    'notifications.refusal.rule.close_own_event': 'لا يمكن أن تُغلق القاعدةَ أحداثُ وحدة التنبيهات نفسها.',
    'notifications.refusal.rule.close_match_shape': 'السطر {line}: اكتب alert_field = event_field.',
    'notifications.refusal.rule.close_match_required': 'حدّد أي حقل في الحدث المُغلِق يسمّي الشيء نفسه الذي في التنبيه.',
    'notifications.refusal.rule.close_too_many': 'على الأكثر {max} أحداث مُغلِقة، و{max} أسطر تطابق لكل منها.',
    'notifications.refusal.alert.not_found': 'لا يوجد هذا التنبيه.',
    'notifications.refusal.alert.already_closed': 'هذا التنبيه مُغلق من قبل.',
    'value.progress.resent': 'أُعيد إرساله، في الطريق',
    'screen.notifications.deliveries.column.resend_count': 'مرات إعادة الإرسال',
    'screen.notifications.deliveries.column.alert_closed_at': 'أُغلق التنبيه',
    'screen.notifications.deliveries.action.resend': 'إعادة الإرسال',
    'screen.notifications.deliveries.field.reason': 'السبب',
    'screen.notifications.deliveries.field.reason.help': 'اختياري. يُرسل الإشعار نفسه مرة أخرى على قناته، بعد التحقق من العنوان والموافقة والقالب من جديد. ثلاث مرات على الأكثر.',
    'notifications.refusal.delivery.resend_in_app': 'الجرس يحمله أصلًا؛ لا شيء يُعاد إرساله.',
    'notifications.refusal.delivery.resend_pending': 'ما زال في طريقه.',
    'notifications.refusal.delivery.resend_blocked': 'لم يُرسل باختيار الشخص، أو أُغلق تنبيهه؛ وإعادة إرساله تتجاوز ذلك.',
    'notifications.refusal.delivery.resend_limit': 'أُعيد إرساله {max} مرات من قبل.',
    'notifications.refusal.delivery.resend_too_soon': 'أُعيد إرساله قبل أقل من {minutes} دقائق. أعد المحاولة بعد قليل.',
    'documents.items.field.issuer_name': 'جهة الإصدار',
    'documents.items.field.issuer_name.help': 'الجهة التي أصدرت الوثيقة، كتابةً. مطلوبة حين يشترطها النوع.',
    'documents.items.field.issuer_party_id': 'جهة الإصدار من السجل',
    'documents.items.field.issuer_party_id.help': 'اختياري: جهة الإصدار طرفًا في السجل. وإن لم تُكتب الجهة، كُتب اسمه كما هو الآن.',
    'documents.items.col.issuer_name': 'جهة الإصدار',
    'documents.items.col.issuer_party_id': 'الجهة المُصدِرة في السجل',
    'documents.types.field.issuer_required': 'تُذكر جهة الإصدار',
    'documents.types.field.issuer_required.help': 'تُرفض وثيقة جديدة من هذا النوع بلا جهة إصدارها. وما حُفظ قبل ذلك يبقى كما هو.',
    'documents.types.col.issuer_required': 'تُذكر جهة الإصدار',
    'documents.refusal.issuer_required': 'هذا النوع من الوثائق يذكر جهة إصداره؛ اكتب الجهة.',
    'documents.refusal.issuer_party_unknown': 'لا يوجد هذا الطرف في السجل، أو دُمج في غيره.',
    'documents.refusal.issuer_party_unavailable': 'لم يُجب سجل الأطراف. أعد المحاولة بعد قليل.',
    'change.field.document.issuer_name': 'جهة الإصدار',
    'change.field.document.issuer_party_id': 'جهة الإصدار من السجل',
    'change.field.type.issuer_required': 'تُذكر جهة الإصدار',
    // ── من شاهد الملف (H7) ──
    'attachments.col.seen_by_party': 'شاهده الطرف',
    'attachments.seen.seen': 'شاهده الطرف',
    'attachments.col.portal_first_viewed_at': 'أول مشاهدة من الطرف',
    'attachments.col.viewers': 'المشاهدون',
    'attachments.action.views': 'من شاهده',
    'attachments.views.title': 'من شاهد {file}',
    'attachments.views.lede': 'كل من أُعطي رابطًا لهذا الملف، الأحدث أولًا.',
    'attachments.views.empty': 'لم يشاهد أحد هذا الملف بعد.',
    'attachments.views.kind.member': 'عضو',
    'attachments.views.kind.portal': 'الطرف',
    'attachments.views.first': 'أول مشاهدة',
    'attachments.views.last': 'آخر مشاهدة',
    'attachments.views.count': 'المرات',
    'attachments.views.unnamed_member': 'عضو سابق',
    'attachments.views.unnamed_party': 'طرف لا تملك الاطلاع عليه',
    'attachments.views.more': 'يظهر أحدث {shown} من {total} مشاهدًا.',
    'attachments.views.no_row': 'افتح هذا من ملف على السجل.',
    'attachments.refusal.view_not_recorded': 'تعذّر تسجيل المشاهدة، فلم يُصدَر رابط. أعد المحاولة بعد قليل.',
    // ── بصمة الملف، والتقاط اللحظة (H8) ──
    'attachments.refusal.file_reused': 'أُرفق هذا الملف نفسه من قبل. ملف من هذا النوع يُلتقط من جديد.',
    'attachments.refusal.file_too_large_to_check': 'هذا الملف أكبر من أن نتحقق أنه لم يُرفق من قبل.',
    'attachments.refusal.capture_required': 'ملف من هذا النوع يذكر وقت التقاطه.',
    'attachments.refusal.capture_too_old': 'التُقط هذا قبل أكثر من {max_age_minutes} دقيقة. التقطه من جديد.',
    'attachments.refusal.capture_in_future': 'وقت الالتقاط بعد الآن. تحقق من ساعة الجهاز.',
    'media.refusal.reused': 'سبق أن حُجز الملف نفسه في هذا النطاق.',
    'media.refusal.not_fingerprinted': 'لا بصمة لهذا الملف، فلا يمكن حجزه.',
    'media.refusal.not_ready': 'لم يكتمل رفع الملف بعد.',
    'media.refusal.claimed_elsewhere': 'الملف محجوز في نطاق آخر.',
    'media.refusal.scope': 'النطاق حروف لاتينية صغيرة وأرقام و_ ونقاط.',
    'media.refusal.sha256': 'البصمة 64 خانة ست عشرية.',
    'media.refusal.fingerprint_mismatch': 'المحتوى المرفوع لا يطابق البصمة المعلنة.',
    'media.refusal.not_your_file': 'لا يحجز الملف إلا من خزّنه.',
    'media.refusal.not_found': 'هذا الملف ليس في مساحة العمل هذه.',
    'change.field.file.sha256': 'البصمة',
    'change.field.file.fingerprint_scope': 'محجوز في نطاق',
    'change.field.file.claimed_at': 'تاريخ الحجز',
    // ── أرقام القاعدة والشاشة التي تفتحها (H9) ──
    'screen.notifications.rules.field.figures': 'الأرقام',
    'screen.notifications.rules.field.figures.help': 'أرقام يعرضها التنبيه من حدثه، في الجرس وفي البريد: حقل الحدث، واسم بكل لغة، ونوع الرقم. حتى ثمانية.',
    'screen.notifications.rules.field.figures.field': 'حقل الحدث',
    'screen.notifications.rules.field.figures.name_ar': 'الاسم بالعربية',
    'screen.notifications.rules.field.figures.name_en': 'الاسم بالإنجليزية',
    'screen.notifications.rules.field.figures.kind': 'النوع',
    'screen.notifications.rules.field.link': 'يفتح على',
    'screen.notifications.rules.field.link.help': 'الشاشة التي يفتح عليها التنبيه، تُكتب module/screen. فارغة: السجل الذي يسمّيه الحدث، أو لا شيء.',
    'screen.notifications.rules.action.create.section.shows': 'ما يعرضه',
    'screen.notifications.rules.action.edit.section.shows': 'ما يعرضه',
    'screen.notifications.rules.column.figures_text': 'الأرقام',
    'screen.notifications.rules.column.link': 'يفتح على',
    'value.figure_kind.count': 'عدد',
    'value.figure_kind.percent': 'نسبة مئوية',
    'value.figure_kind.minutes': 'دقائق',
    'value.figure_kind.money': 'مبلغ',
    'notifications.figures': 'الأرقام',
    'notifications.refusal.rule.figures_shape': 'الأرقام قائمة: حقل الحدث، واسم بكل لغة، والنوع.',
    'notifications.refusal.rule.figures_too_many': '{max} أرقام على الأكثر.',
    'notifications.refusal.rule.figure_field': 'الرقم {line}: اكتب حقل الحدث الذي يقرؤه، مثل counts.open.',
    'notifications.refusal.rule.figure_name': 'الرقم {line}: اسم بالعربية وبالإنجليزية، {max} حرفًا على الأكثر لكل منهما.',
    'notifications.refusal.rule.figure_kind': 'الرقم {line}: عدد أو نسبة مئوية أو دقائق أو مبلغ.',
    'notifications.refusal.rule.link_shape': 'اكتب الشاشة على صورة module/screen.',
    'change.field.rule.figures': 'الأرقام',
    'change.field.rule.link': 'يفتح على',
};
//# sourceMappingURL=i18n-core-hooks.js.map